module.exports = __webpack_public_path__ + "img/company-name.83dbc87b.png";